import { useMemo, useState } from "react";
import { useTranslation } from "@helpers/translate";

export const DATE_FILTERS = {
  TODAY: "today",
  YESTERDAY: "yesterday",
  LAST_7_DAYS: "last_7_days",
  LAST_30_DAYS: "last_30_days",
  CURRENT_MONTH: "current_month",
  PREVIOUS_MONTH: "previous_month",
  ALL_TIME: "all_time",
  CUSTOM_RANGE: "custom_range",
};

export const getDateRangeByFilter = (
  filter,
  customRange = { dateFrom: null, dateTo: null },
) => {
  const today = new Date();

  const formatDate = (date) => date.toISOString().split("T")[0];

  const dateTo = new Date(today);
  const dateFrom = new Date(today);

  switch (filter) {
    case DATE_FILTERS.YESTERDAY:
      dateFrom.setDate(today.getDate() - 1);
      dateTo.setDate(today.getDate() - 1);
      break;

    case DATE_FILTERS.LAST_7_DAYS:
      dateFrom.setDate(today.getDate() - 6);
      break;

    case DATE_FILTERS.LAST_30_DAYS:
      dateFrom.setDate(today.getDate() - 29);
      break;

    case DATE_FILTERS.CURRENT_MONTH:
      dateFrom.setDate(1);
      break;

    case DATE_FILTERS.PREVIOUS_MONTH:
      dateFrom.setMonth(today.getMonth() - 1);
      dateFrom.setDate(1);
      dateTo.setDate(0);
      break;

    case DATE_FILTERS.ALL_TIME:
      return {
        dateFrom: "2026-01-01",
        dateTo: formatDate(today),
      };

    case DATE_FILTERS.CUSTOM_RANGE:
      return customRange;

    case DATE_FILTERS.TODAY:
    default:
      break;
  }

  return {
    dateFrom: formatDate(dateFrom),
    dateTo: formatDate(dateTo),
  };
};

export const useTradingDateFilter = () => {
  const { __ } = useTranslation();

  const [selectedDateFilter, setSelectedDateFilter] = useState(
    DATE_FILTERS.TODAY,
  );

  const [customRange, setCustomRange] = useState({
    dateFrom: null,
    dateTo: null,
  });

  const dateRange = useMemo(
    () => getDateRangeByFilter(selectedDateFilter, customRange),
    [selectedDateFilter, customRange],
  );

  const dateFilterLabels = useMemo(
    () => ({
      [DATE_FILTERS.TODAY]: __("common.today"),
      [DATE_FILTERS.YESTERDAY]: __("common.yesterday"),
      [DATE_FILTERS.LAST_7_DAYS]: __("common.last_7_days"),
      [DATE_FILTERS.LAST_30_DAYS]: __("common.last_30_days"),
      [DATE_FILTERS.CURRENT_MONTH]: __("common.current_month"),
      [DATE_FILTERS.PREVIOUS_MONTH]: __("common.previous_month"),
      [DATE_FILTERS.ALL_TIME]: __("common.all_time"),
      [DATE_FILTERS.CUSTOM_RANGE]: __("common.custom_range"),
    }),
    [__],
  );

  return {
    selectedDateFilter,
    setSelectedDateFilter,
    customRange,
    setCustomRange,
    dateRange,
    dateFilterLabels,
  };
};
